import script from "./VersionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionBar.vue?vue&type=script&setup=true&lang=js"

import "./VersionBar.vue?vue&type=style&index=0&id=7d3e1c50&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3e1c50"]])

export default __exports__